// extracted by mini-css-extract-plugin
export default {"shadow":"style-module--shadow--6IKNL"};